// src/data/items.ts — Catálogo modular Fase 5
export type ItemCategory = 'curacion'|'captura'|'combate'|'mision'|'clave'|'especial';
export type ItemDef = {
  id: string;
  name: string;
  description: string;
  category: ItemCategory;
  price: number; // en Aurel, 0 = no vendible
  sellPrice: number;
  stackable: boolean;
  usableInBattle: boolean;
  usableOutBattle: boolean;
  keyItem?: boolean; // no vendible
  icon?: string; // emoji placeholder
};

export const ITEMS: Record<string, ItemDef> = {
  nucleo_vinculo: { id:'nucleo_vinculo', name:'Núcleo de Vínculo', description:'Dispositivo estándar para vincular Asterias salvajes.', category:'captura', price: 120, sellPrice: 60, stackable:true, usableInBattle:true, usableOutBattle:false, icon:'⬢' },
  pocion_aurea: { id:'pocion_aurea', name:'Poción Áurea', description:'Restaura 35 PS de una Asteria.', category:'curacion', price: 80, sellPrice: 40, stackable:true, usableInBattle:true, usableOutBattle:true, icon:'🧪' },
  cristal_lumen: { id:'cristal_lumen', name:'Cristal Lumen', description:'Restaura 3 EN y cura agotamiento leve.', category:'curacion', price: 60, sellPrice: 30, stackable:true, usableInBattle:true, usableOutBattle:true, icon:'💎' },
  pan_aureliano: { id:'pan_aureliano', name:'Pan Aureliano', description:'Alimento de Villa Aurelia. Restaura 15 PS fuera de combate.', category:'curacion', price: 30, sellPrice: 15, stackable:true, usableInBattle:false, usableOutBattle:true, icon:'🍞' },
  baya_lumen: { id:'baya_lumen', name:'Baya Lumen', description:'Cura confusión e interferencia.', category:'curacion', price: 50, sellPrice: 25, stackable:true, usableInBattle:true, usableOutBattle:true, icon:'🫐' },
  antidoto_aureo: { id:'antidoto_aureo', name:'Antídoto Áureo', description:'Cura agotamiento y ralentizado.', category:'curacion', price: 70, sellPrice: 35, stackable:true, usableInBattle:true, usableOutBattle:true, icon:'🌿' },
  estimulante: { id:'estimulante', name:'Estimulante', description:'Restaura 5 EN en combate.', category:'combate', price: 90, sellPrice: 45, stackable:true, usableInBattle:true, usableOutBattle:false, icon:'⚡' },
  carta_aurelia: { id:'carta_aurelia', name:'Carta de Aurelia', description:'Carta sellada para el investigador Kai. Objeto de misión.', category:'mision', price: 0, sellPrice: 0, stackable:false, usableInBattle:false, usableOutBattle:false, keyItem:true, icon:'✉️' },
  fragmento_geoda: { id:'fragmento_geoda', name:'Fragmento de Geoda', description:'Fragmento brillante de Geodra. Para Ori.', category:'mision', price: 0, sellPrice: 0, stackable:false, usableInBattle:false, usableOutBattle:false, keyItem:true, icon:'🪨' },
  amuleto_vinculo: { id:'amuleto_vinculo', name:'Amuleto de Vínculo', description:'Aumenta vínculo +5 al equipar (futuro).', category:'especial', price: 500, sellPrice: 250, stackable:false, usableInBattle:false, usableOutBattle:true, icon:'🔮' },
  mapa_ruta: { id:'mapa_ruta', name:'Mapa de Ruta', description:'Revela secretos de Ruta Aurelia.', category:'clave', price: 0, sellPrice: 0, stackable:false, usableInBattle:false, usableOutBattle:true, keyItem:true, icon:'🗺️' },
};

export const ITEM_LIST = Object.values(ITEMS);

export function getItem(id:string): ItemDef | undefined { return ITEMS[id]; }

export const SHOP_CATALOG: { id:string; price:number }[] = [
  { id:'nucleo_vinculo', price:120 },
  { id:'pocion_aurea', price:80 },
  { id:'cristal_lumen', price:60 },
  { id:'pan_aureliano', price:30 },
  { id:'baya_lumen', price:50 },
  { id:'antidoto_aureo', price:70 },
  { id:'estimulante', price:90 },
];

export const CATEGORY_LABELS: Record<ItemCategory,string> = {
  curacion:'Curación', captura:'Captura', combate:'Combate', mision:'Misión', clave:'Clave', especial:'Especial'
};
